import React from "react";
import Image from "../Image/Image";
import { useAppContent } from "../../../shared/AppContent";

const InsideHeader = ({ userDetail, classes, goTo, handleEdit }) => {
  const { personalDetailsContent, mobileNoContent, 
    cityContent,panContent, dobContent} = useAppContent();
  const getEditButtonDisplay = () => {
    return goTo === "personalDetails" || goTo === "otpview"
  }

  return (
    <div className={classes.InfoHeader}>
      <div className={classes.NameHeader}>
        <label className={classes.PersonalInfoLabels}>
          {personalDetailsContent.heading.text}
        </label>
        <div className={classes.PersonalInfoValues}>
          {`${userDetail?.firstName} ${userDetail?.middleName ? userDetail?.middleName : ""} ${userDetail?.lastName}`}
        </div>
      </div>
      <div className={classes.AlignHeader}>
        <label className={`${classes.PersonalInfoLabels} ${classes.ContactInfo}`}>
          {mobileNoContent.headingLabel}
        </label>
        <div
          className={`${classes.PersonalInfoValues} ${classes.ContactInfo}`}
        >
          {`+91 ${(userDetail?.mobileNo).substring(0, 5) +
            " " +
            (userDetail?.mobileNo).substring(5, 10)
            }`}
        </div>
      </div>
      {(goTo === "pan" || goTo === "email") && (
        <>
          <div className={classes.CityHeader}>
            <label className={classes.PersonalInfoLabels}>
              {cityContent.headingLabel}
            </label>
            <div className={classes.PersonalInfoValues}>
              {userDetail?.resiCity}
            </div>
          </div>
        </>
      )}

      {goTo === "email" && (
        <>
          <div className={classes.PanHeader}>
            <label className={classes.PersonalInfoLabels}>
              {panContent.headingLabel}
            </label>
            <div className={classes.PersonalInfoValues}>
              {userDetail?.panNumber}
            </div>
          </div>
          <div className={classes.DobHeader}>
            <label className={classes.PersonalInfoLabels}>
              {dobContent.headingLabel}
            </label>
            <div className={classes.PersonalInfoValues}>
              {userDetail?.dob}
            </div>
          </div>
        </>
      )}

      {getEditButtonDisplay() && (
        <div
          className={classes.EditInfo}
          onClick={() => handleEdit(false)}
        >
          <Image
            filename={"Group510"}
            ext="png"
            renditions={["2x"]}
            alt=""
          />
          <span className={classes.EditButton}>{personalDetailsContent.edit}</span>
        </div>
      )}
    </div>
  )
}

export default InsideHeader;